import InviteStudentList from '../../slices/registration/invite_student/InviteStudentList'
import studentInstituteEnrollmentListSlice from '../../slices/registration/student_institute_enrollments/StudentInstituteEnrollmentList'
import studentInstituteEnrollmentDetailsSlice from '../../slices/registration/student_institute_enrollments/StudentInstituteEnrollmentDetails'

const registrationReducer = {
    inviteStudentList: InviteStudentList,
    studentInstituteEnrollmentList: studentInstituteEnrollmentListSlice,
    studentInstituteEnrollmentDetails: studentInstituteEnrollmentDetailsSlice,
};

export default registrationReducer;
